﻿import document from 'document';

export const gtmEventHandler = () => {
  
    const selectors = {
        gtmLinkEvent: 'form input[data-gtm-event]',
    };

    const onClick = (e) => {
        const eventData = e.currentTarget.getAttribute('data-gtm-event');

        if (eventData) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event':  eventData
            });  
            e.currentTarget.removeEventListener('click', onClick);
        }
    };

    const _clickHandler = link => {
        link.addEventListener('click', onClick);
    };

    const _linkEventHandler = () => {
        const gtmLinkEvents = [...document.querySelectorAll(selectors.gtmLinkEvent)];

        gtmLinkEvents.forEach(link => {
            _clickHandler(link)
        });
    };
    
    const init = () => {
        _linkEventHandler();
    };

    return {
        init: init,
    };
};
